export const devAccessToken =
  "_act-sbx-jwt-eyJhbGciOiJub25lIn0.eyJqdGkiOiJfYWN0LXNieC02ZWY5ZmMxYS0wZTE2LTQzYzMtYjZiNy1mNTUwODVlNWQ5ODItdjIiLCJ1cmwiOiJodHRwczovL2FwaS5zdW1zdWIuY29tIn0.-v2";
// need to generate always here https://docs.sumsub.com/reference/generate-access-token

export const SUMSUB_TYPE_PREFIX = "idCheck";
export const SUMSUB_ON_APPLICANT_STATUS_CHANGED = "onApplicantStatusChanged";
const SUMSUB_CUSTOMIZATION_NAME = "MyWebSDK";

export const config = {
  theme: "light",
  lang: "en",
  country: "USA",
  userData: {
    country: "USA",
  },
  customizationName: SUMSUB_CUSTOMIZATION_NAME, // Overrides the level customization value for a specific SDK run.
};

export const options = {
  addViewportTag: false,
  adaptIframeHeight: true,
};

// Vouched SSN attempts an order starts with (fallback when the question omits it).
export const DEFAULT_VOUCHED_ATTEMPTS = 3;
